module.exports = __webpack_public_path__ + "img/sotherma_blue1.509cb8fe.png";